export enum NoteMode {
  'CREATE' = 'CREATE',
  'UPDATE' = 'UPDATE',
}
